import { Login } from './Login'
import ResetPassword from './ResetPassword'
import Signup from './Signup'
import SignupOtp from './SignupOtp'

export const ROUTES = [
  {
    component: Login,
    isProtected: false,
    showMenu: false,
    path: '/auth/login',
    slug: 'login',
    title: 'Login',
    redirectTo: '/orders',
  },
  {
    component: Signup,
    isProtected: false,
    showMenu: false,
    path: '/auth/signup',
    slug: 'login',
    title: 'Login',
    redirectTo: '/orders',
  },
  {
    component: ResetPassword,
    isProtected: false,
    showMenu: false,
    path: '/auth/reset-password',
    slug: 'reset-password',
    title: 'reset-password',
    redirectTo: '/orders',
  },
  {
    component: SignupOtp,
    path: '/auth/signup-otp',
    slug: 'signup-otp',
    title: 'signup-otp',
    isProtected: false,
    showMenu: false,
  },
]
